import { useEffect } from "react";

function useDisableContextMenu(userProfile) {
  useEffect(() => {
    if (userProfile?.superRank === "admin") {
      return;
    }

    const handleContextMenu = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    document.addEventListener("contextmenu", handleContextMenu, false);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu, false);
    };
  }, [userProfile]);
}

export default useDisableContextMenu;
